import { useState, useEffect, useCallback } from 'react';
import { checkAgentHealth } from '../lib/api';
import type { AgentStatus } from '../types';

const INTERVAL_MS = 30_000;

export function useAgentStatus() {
  const [status, setStatus] = useState<AgentStatus>({
    name:      'oski',
    status:    'ok',
    checkedAt: new Date().toISOString(),
  });
  const [checking, setChecking] = useState(true);

  const check = useCallback(async () => {
    setChecking(true);
    const result = await checkAgentHealth();
    setStatus(result);
    setChecking(false);
  }, []);

  useEffect(() => {
    check();
    const interval = setInterval(check, INTERVAL_MS);
    return () => clearInterval(interval);
  }, [check]);

  return { status, checking, recheck: check };
}
